import React, { useEffect, useState } from 'react';
import { MotionConfig, motion } from 'framer-motion';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ProjectsSection } from './components/ProjectsSection';
import { StrengthsSection } from './components/StrengthsSection';
import { SiteFooter } from './components/SiteFooter';
import { profileContent } from './data/profile';
import type { Lang } from './types/profile';
export function App() {
  const [lang, setLang] = useState<Lang>('en');
  const content = profileContent[lang];
  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = content.documentTitle;
  }, [lang, content.documentTitle]);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2wj8dbo48im46">
      <div className="min-h-screen w-full bg-ivory font-sans text-charcoal antialiased selection:bg-sage-tint" data-id="element-1" data-mp="2wi5l9cv6edmo">
        <SiteHeader lang={lang} content={content} onLangChange={setLang} data-id="element-2" data-mp="23vcmh01cjofb" />
        <motion.main key={lang} data-reveal initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.35
      }} data-id="element-3" data-mp="23t8g8bfz6dbv">
          <Hero lang={lang} content={content} data-id="element-4" data-mp="3mjq2lgp4euvl" />
          <ProjectsSection lang={lang} content={content} data-id="element-5" data-mp="3rbra6pbcfxfa" />
          <StrengthsSection lang={lang} content={content} data-id="element-6" data-mp="3recdzjv7cnfo" />
        </motion.main>
        <SiteFooter content={content} data-id="element-7" data-mp="5ggje8nxyxz" />
      </div>
    </MotionConfig>;
}